import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=01e71fc0&scoped=true&"
import script from "./JobList.vue?vue&type=script&lang=js&"
export * from "./JobList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e71fc0",
  null
  
)

export default component.exports